const openModal = () => document.querySelector("[aria-modal=true]")
const initFlowbite = () => window.dispatchEvent(new Event("turbo:after-stream-render"))

let pendingInit = null

const initFlowbiteWhenClosed = (modal) => {
  pendingInit?.disconnect()
  pendingInit = new MutationObserver((_records, observer) => {
    if (modal.isConnected && modal.getAttribute("aria-modal") === "true") return

    observer.disconnect()
    pendingInit = null
    initFlowbite()
  })
  pendingInit.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ["aria-modal"] })
}

let renderBeforeFlowbite = null

window.addEventListener("turbo:before-stream-render", (event) => {
  renderBeforeFlowbite = event.detail.render
}, true)

window.addEventListener("turbo:before-stream-render", (event) => {
  const render = renderBeforeFlowbite
  event.detail.render = async (streamElement) => {
    await render(streamElement)
    const modal = openModal()
    modal ? initFlowbiteWhenClosed(modal) : initFlowbite()
  }
})

document.addEventListener("turbo:render", (event) => {
  const modal = openModal()
  if (!modal) return

  event.stopImmediatePropagation()
  initFlowbiteWhenClosed(modal)
})

const isBackdrop = (node) => node.parentElement === document.body && node.matches(".fixed.inset-0.z-40")

document.addEventListener("turbo:before-morph-element", (event) => {
  const modal = openModal()
  if (modal && (event.target === modal || isBackdrop(event.target))) event.preventDefault()
})

document.addEventListener("turbo:before-morph-attribute", (event) => {
  if (openModal() && event.target === document.body) event.preventDefault()
})
